import { render, staticRenderFns } from "./GameNPC.vue?vue&type=template&id=3b72242f&"
import script from "./GameNPC.vue?vue&type=script&lang=js&"
export * from "./GameNPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports